import RepairSVG from "../../utils/assets/client/troubleshooting.svg";
import NextSVG from "../../utils/assets/next.svg";
import { Link } from "react-router-dom";
import "./admin.css";

const DashBoardCards = ({ CardData }) => {
  return (
    <>
      <div className="card p-4  w-100">
        <div>
          <img src={CardData.image} width={35} alt="ReapirSVG" />
        </div>
        <div className="f-24">
          <p className="py-2 m-0">{CardData.title}</p>
        </div>
        <p className="txt-secondary">{CardData.desc}</p>
        <Link
          to={CardData.allLink}
          className="link_text d-flex justify-content-center align-items-center"
        >
          <button className="w-100 btn bg-black card_radius text-white">
            <span className="m_r txt-p">View All</span>{" "}
            <img src={NextSVG} width={18} alt="next" />
          </button>
        </Link>
      </div>
    </>
  );
};

export default DashBoardCards;
